import { Row, Col, Card, Table, DatePicker, Tag } from "antd";

import React, { useState, useEffect } from "react";

import moment from "moment";
import lang from "../../helper/langHelper";
const { RangePicker } = DatePicker;

function LastAppointments({ data, loading }) {
  const [list, setList] = useState(data);
  const [pagination, setPagination] = useState(5);

  useEffect(() => {
    if (!data) return;
    setList(data);
    setPagination(data?.length);
    console.log("data ::", data);
  }, [data]);

  const columns = [
    {
      title: "Booking ID",
      dataIndex: "bookingId",
      key: "bookingId",
      render: (_, { bookingId }) => {
        return <span className="">{bookingId}</span>;
      },
    },
    {
      title: "Customer",
      dataIndex: "userId",
      key: "userId",
      render: (_, { userId }) => {
        return (
          <span className="">
            {userId?.name}, {userId?.email}, {userId?.location}
          </span>
        );
      },
    },
    {
      title: "Vendor",
      dataIndex: "vendorId",
      key: "vendorId",
      render: (_, { vendorId }) => {
        return (
          <span className="">
            {vendorId?.name}, {vendorId?.email}, {vendorId?.location}
          </span>
        );
      },
    },
    {
      title: "Amount (AED)",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Expiration Date",
      dataIndex: "subscriptionExpireDate",
      key: "subscriptionExpireDate",
      render: (_, { subscriptionExpireDate }) => {
        return <span className="">{moment(subscriptionExpireDate).format("ll") || "-"}</span>;
      },
    },
    {
      title: "Booking Slot",
      dataIndex: "slot",
      key: "slot",
      render: (_, { slot }) => {
        return <span className="">{slot || "-"}</span>;
      },
    },
    {
      title: "Service",
      dataIndex: "serviceId",
      key: "serviceId",
      render: (_, { serviceId }) => {
        return <span>{serviceId?.name || "-"}</span>;
      },
    },
    {
      title: "Booking Status",
      key: "bookingStatus",
      render: (_, { bookingStatus }) => {
        let color = bookingStatus === "completed" ? "green" : bookingStatus === "cancelled" ? "red" : bookingStatus === "refunded" ? "orange" : "blue";
        return (
          <Tag
            color={color}
            key={bookingStatus}
          >
            {bookingStatus}
          </Tag>
        );
      },
    },
  ];

  return (
    <>
      <div className="tabled bannerMain">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <div className="table-responsive customPagination">
              <Table
                loading={loading}
                columns={columns}
                dataSource={list}
                pagination={{
                  defaultPageSize: 10,
                  responsive: true,
                  total: pagination,
                  // showSizeChanger: true,
                  // pageSizeOptions: ["10", "20", "30", "50"],
                }}
                className="ant-border-space"
              />
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default LastAppointments;
